import { styled } from '@spazious/dollhouse-theme';

export interface LoaderLabelProps extends React.HTMLAttributes<HTMLSpanElement> {}

export const LoaderLabel = styled.span`
  display: inline-block;
  position: relative;
  font-variant-numeric: tabular-nums;
  margin-top: 0.8em;
  color: var(--spz-sys-color-on-surface);
  font-size: 0.6em;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', 'Helvetica Neue', Helvetica,
    Arial, Roboto, Ubuntu, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  white-space: nowrap;
`;

export default LoaderLabel;
